import React, { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import './CookieBanner.css';

const CookiesBanner = () => {
  const [showBanner, setShowBanner] = useState(true);
  const [language, setLanguage] = useState('pt');

  useEffect(() => {
    // Check if the user has accepted cookies
    const cookiesAccepted = Cookies.get('cookies_accepted');
    if (cookiesAccepted === 'true') {
      // If cookies have been accepted, hide the banner
      setShowBanner(false);
    }

    const selectedLanguage = localStorage.getItem('selectedLanguage') || 'pt';
    setLanguage(selectedLanguage);
  }, []);

  const handleAcceptCookies = () => {

    Cookies.set('cookies_accepted', 'true', { expires: 365 }); // Expires after 365 days

    setShowBanner(false);
  };

  return (
    <>
      {showBanner && (
        <div id="cookies-banner" className="er-cookie" role="dialog" aria-live="polite">
          <p className="er-cookieText">
            {language === 'pt'
              ? 'Este website utiliza cookies para melhorar a tua experiência.'
              : 'This website uses cookies to ensure you get the best experience.'}
          </p>
          <div className="er-cookieRow">
            <button className="er-cookieBtn" onClick={handleAcceptCookies}>
              {language === 'pt' ? 'Aceitar' : 'Got it'}
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default CookiesBanner;